import Vue from 'vue';
import './registerServiceWorker';
import router from './router';

import { VueDiContainer } from 'vue-di-container';

// Plugins
import najizToast, { IToasterAPI } from '@moj/najiz-toastify';
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import initializeApplication from '@/plugins/application-initialization';
import najizMui from '@moj/najiz-mui';
// Components
import App from './views/App/app';
// styles
import '../public/styles/main.scss';
import AxiosService from './services/axios';
import LoaderService from './services/loader';
import UserService from './services/user';
import TelemetryService from './services/TelemetryService';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(VueDiContainer);
Vue.use(najizMui);
Vue.use(najizToast);

declare module 'vue/types/vue' {
  interface Vue {
    $appInsights: any;
    $nToaster: IToasterAPI;
  }
}

declare global {
  interface Window {
    $config: any;
    $disableNewRequestsPeriod: any;
    ShowLoader(): void;
    HideLoader(): void;
  }
}

initializeApplication().then(() => {
  new Vue({
    i18n,
    router,
    vuetify,
    diProvide: [
      AxiosService,
      LoaderService,
      UserService,
      TelemetryService,
    ],
    render: (h) => h(App),
  }).$mount('#app');
});
